import type { IconProps } from './types';

export const TrashIcon: React.FC<IconProps> = (props) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            strokeWidth={1.5}
            {...props}
        >
            <path
                d="M18.1698 8.92004V18.17C18.1696 18.9868 17.845 19.7701 17.2674 20.3476C16.6899 20.9252 15.9066 21.2498 15.0898 21.25H8.91984C8.10306 21.2498 7.3198 20.9252 6.74225 20.3476C6.16469 19.7701 5.84011 18.9868 5.83984 18.17V8.92004"
                stroke="currentColor"
                strokeLinejoin="round"
            />
            <path d="M3.78027 5.82996H20.2203" stroke="currentColor" strokeLinejoin="round" />
            <path
                d="M8.91992 5.83C8.91992 5.01313 9.24442 4.22972 9.82203 3.65211C10.3996 3.0745 11.1831 2.75 11.9999 2.75C12.8168 2.75 13.6002 3.0745 14.1778 3.65211C14.7554 4.22972 15.0799 5.01313 15.0799 5.83"
                stroke="currentColor"
                strokeLinejoin="round"
            />
            <path d="M9.94043 12L14.0604 16.11" stroke="currentColor" strokeLinejoin="round" />
            <path d="M14.0604 12L9.94043 16.11" stroke="currentColor" strokeLinejoin="round" />
        </svg>
    );
};
